import {
    CHECKOUT_SUBMIT,
    CHECKOUT_SUBMIT_ERROR,
    CHECKOUT_SET_CUSTOMER_INFO,
    CHECKOUT_SET_CAMPAIGN_CODE,
    CHECKOUT_SET_DELIVERY,
    CHECKOUT_SET_PAYMENT,
    CHECKOUT_SET_ORDER_NOTE,
    CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
    CHECKOUT_SET_PRIVATE_CUSTOMER,
    CHECKOUT_SET_PAYMENT_WIDGET,
    CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
    CHECKOUT_SET_SIGN_UP,
    CHECKOUT_SHOW_FULL_FORM,
    CHECKOUT_SEARCH_COMPANY_ADDRESS,
    CHECKOUT_SET_REQUESTEDSHIPPINGDATE,
    CHECKOUT_SET_COUNTRY
} from '../Actions/Checkout.action';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    payload: {
        alternativeAddress: {},
        customerDetails: {},
        selectedCompanyAddressId: null,
        selectedDeliveryMethod: {},
        selectedPaymentMethod: {},
        campaignCode: '',
        orderNote: {},
        paymentWidget: null,
        isBusinessCustomer: false,
        signUp: false,
        acceptTermsOfCondition: false,
        authenticated: false,
        deliveryMethods: [],
        paymentMethods: [],
        companyAddresses: [],
        responseUrl: '',
        cancelUrl: '',
        redirectUrl: '',
        searchCompanyAddress: [],
        requestedShippingDate: ''

    },
    errors: {},
    result: {},
    isSubmitting: false,
    showFullForm: false,
    selectedPerson: { id: -1, name: '', isSelected: false }
}

// Helper to split address pipe for alternativeAddress
function normalizeAlternativeAddress(addressObj) {
    if (
        addressObj &&
        typeof addressObj.address === 'string' &&
        addressObj.address.includes('|')
    ) {
        const [address, addressExtra] = addressObj.address.split('|').map(s => s.trim());
        return {
            ...addressObj,
            address,
            addressExtra: addressExtra || addressObj.addressExtra || ''
        };
    }
    return addressObj;
}

export const checkout = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CHECKOUT_SUBMIT_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        case CHECKOUT_SHOW_FULL_FORM:
        case CHECKOUT_SUBMIT:
            // Check if alternativeAddress exists in payload and normalize it
            return {
                ...state,
                ...payload,
                payload: {
                    ...state.payload,
                    ...(
                        payload.payload
                            ? {
                                ...payload.payload,
                                alternativeAddress: normalizeAlternativeAddress(payload.payload.alternativeAddress)
                            }
                            : {}
                    ),
                }
            }
        case CHECKOUT_SET_CUSTOMER_INFO:
            // Special handling for alternativeAddress pipe split
            if (payload.key === 'alternativeAddress' && payload.data) {
                return {
                    ...state,
                    payload: {
                        ...state.payload,
                        [payload.key]: normalizeAlternativeAddress({
                            ...state.payload[payload.key],
                            ...payload.data
                        })
                    },
                };
            }
            return {
                ...state,
                payload: {
                    ...state.payload,
                    [payload.key]: {
                        ...state.payload[payload.key],
                        ...payload.data,
                    }
                },
            }
        case CHECKOUT_SET_COUNTRY: 
            return {
                ...state,
                payload: {
                    ...state.payload,
                    customerDetails: payload
                }
            }
        case CHECKOUT_SEARCH_COMPANY_ADDRESS:
            return {
                ...state,
                payload: {
                    ...state.payload,
                    searchCompanyAddress: payload,
                }
            }
        case CHECKOUT_SET_DELIVERY:
        case CHECKOUT_SET_PAYMENT:
        case CHECKOUT_SET_ORDER_NOTE:
        case CHECKOUT_SET_PAYMENT_WIDGET:
        case CHECKOUT_SET_PRIVATE_CUSTOMER:
        case CHECKOUT_SET_SIGN_UP:
        case CHECKOUT_SET_SELECTED_COMPANY_ADDRESS:
        case CHECKOUT_ACCEPT_TERMS_OF_CONDITION:
        case CHECKOUT_SET_CAMPAIGN_CODE:
        case CHECKOUT_SET_REQUESTEDSHIPPINGDATE:
            // Check if alternativeAddress exists in payload and normalize it
            return {
                ...state,
                payload: {
                    ...state.payload,
                    ...payload,
                    alternativeAddress: normalizeAlternativeAddress(
                        payload.alternativeAddress || state.payload.alternativeAddress
                    )
                }
            }
        default:
            return state;
    }
}